/**
 * POST /auth/create-token - Create a personal access token
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import type { AuthService } from '../auth.service.js'
import { getRequestInfo } from './helpers.js'

export const createTokenAction: ActionDefinition = {
  key: 'create-token',
  label: { en: 'Create Personal Token', es: 'Crear token personal' },
  icon: 'mdi:key-plus',
  scope: 'module',
  group: { en: 'Personal Tokens', es: 'Tokens personales' },
  method: 'POST',
  middleware: (ctx) => ctx.core.middleware['auth'] as MiddlewareHandler,
  input: {
    name: {
      input: 'text',
      required: true,
      label: { en: 'Token Name', es: 'Nombre del token' },
      validation: { max: 100 }
    },
    scope: {
      input: 'text',
      label: { en: 'Permission (readonly or readwrite)', es: 'Permiso (readonly o readwrite)' },
      defaultValue: 'readwrite'
    },
    expires_at: {
      input: 'datetime',
      label: { en: 'Expiration', es: 'Expiración' }
    }
  },
  handler: async (ctx, input, c) => {
    const authService = ctx.services.get<AuthService>('auth')
    const { name, scope, expires_at, _authUserId } = input as { name: string; scope?: string; expires_at?: string; _authUserId?: string }
    if (!_authUserId) throw new ctx.core.errors.UnauthorizedError('Usuario no autenticado')
    return authService.createPersonalToken(
      _authUserId,
      { name, scope: (scope === 'readonly' ? 'readonly' : 'readwrite'), expires_at },
      getRequestInfo(c)
    )
  }
}
